export enum OrganisationUserRoles {
  SuperAdmin = '-1',
  ADMIN = '0',
  EDITOR = '1',
  VIEWER = '2',
}
